/* ── SPCore - Account entrance (login / register / reset / activate) ── */
(function () {
  'use strict';

  function show(el, on) {
    if (el) el.hidden = !on;
  }

  function focusFirst(panel) {
    if (!panel) return;
    var h = panel.querySelector('h1, h2, [tabindex="-1"]');
    if (h) { h.setAttribute('tabindex', '-1'); h.focus(); return; }
    var f = panel.querySelector('input');
    if (f) f.focus();
  }

  function swap(root, which) {
    var login = root.querySelector('[data-sp-auth-panel="login"]');
    var recover = root.querySelector('[data-sp-auth-panel="recover"]');
    show(login, which === 'login');
    show(recover, which === 'recover');
    focusFirst(which === 'recover' ? recover : login);
  }

  function bind(root) {
    if (root.hasAttribute('data-sp-auth-bound')) return;
    root.setAttribute('data-sp-auth-bound', '1');

    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-sp-pw-toggle], [data-sp-auth-show]') : null;
      if (!t) return;

      if (t.hasAttribute('data-sp-pw-toggle')) {
        e.preventDefault();
        var input = document.getElementById(t.getAttribute('data-sp-pw-toggle'));
        if (!input) return;
        var hidden = input.type === 'password';
        input.type = hidden ? 'text' : 'password';
        t.setAttribute('aria-pressed', hidden ? 'true' : 'false');
        t.setAttribute('aria-label', hidden ? 'Hide password' : 'Show password');
        return;
      }

      e.preventDefault();
      swap(root, t.getAttribute('data-sp-auth-show'));
    });

    if (root.querySelector('[data-sp-auth-recovered]')) {
      show(root.querySelector('[data-sp-auth-recovered-msg]'), true);
      swap(root, 'recover');
    } else if (window.location.hash === '#recover') {
      swap(root, 'recover');
    }
  }

  function init(scope) {
    var list = (scope || document).querySelectorAll('[data-sp-auth-root]');
    for (var i = 0; i < list.length; i++) bind(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
}());
